<div class="step-box">
	<div class="row">
		<br>
		<div class="row mt-2 mb-2">
			<div class="col-8">
				<div class="mb-3 d-flex align-items-center">
					<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
					<span style="margin-left: 20px;">{{'global.selected' | translate}}:</span>
					<span class="fw-bold pl-2">
						{{ isSelectAll ? totalItems : selectedItems.size }}
					</span>
					<div class="form-check form-check-inline" style="margin-left: 20px;">
						<input (click)="onSelectAll(isSelectAll)" [checked]="isSelectAll" class="form-check-input" id="check-select-all" name="check-select-all" [ngbTooltip]="'global.select.all' | translate" type="checkbox">
						<label class="form-check-label pl-2" for="check-select-all" jhiTranslate="global.select.all">
							Select all pages
						</label>
					</div>
					<div class="ms-2" style="margin-left: 10px;">
						<button class="btn btn-sm btn-outline-info" (click)="onClearSort($event)" jhiTranslate="global.clear-sort">
						</button>
					</div>
					<span *ngIf="isLoading" class="throbber" style="margin-left: 10px;"></span>
				</div>
			</div>
		</div>
		<div class="table-responsive">
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr jhiSort [(predicate)]="predicate" [(ascending)]="isAscending" [callback]="transition.bind(this)">
					<th *ngIf="!isSelectAll"><input (click)="onSelectPage()" [checked]="isPageSelected()" [title]="'global.select.current.page' | translate" class="form-check-input" data-test="selectCurrentPageCheckbox" [ngbTooltip]="'global.select.current.page' | translate" type="checkbox"></th>
					<th jhiSortBy="germplasmId">
						<span jhiTranslate="multi-trait-query.panel.display.result.table.header.gid"></span>
						<span class="fa fa-sort"></span>
					</th>
					<th jhiSortBy="designation" *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS">
						<span jhiTranslate="multi-trait-query.panel.display.result.table.header.designation"></span>
						<span class="fa fa-sort"></span>
					</th>
					<ng-container *ngIf="traitResult.length > 0 && traitResult[0].traitObservations?.length > 0">
						<ng-container *ngFor="let obs of traitResult[0].traitObservations; trackBy: trackId; index as index">
							<th jhiSortBy="obs-noOfObs-{{index}}">
								<span>
									{{ showTraitHeader(obs) }}
								</span>
								<span class="fa fa-sort"></span>
							</th>
							<th jhiSortBy="obs-successRatio-{{index}}">
								<span jhiTranslate="multi-trait-query.panel.display.result.table.header.success.ratio"></span>
								<span class="fa fa-sort"></span>
							</th>
						</ng-container>
					</ng-container>
					<th jhiSortBy="combinedScore">
						<span jhiTranslate="multi-trait-query.panel.display.result.table.header.combined.score"></span>
						<span class="fa fa-sort"></span>
					</th>
				</tr>
				</thead>
				<tbody *ngIf="traitResult.length else nodata">
				<tr *ngFor="let result of traitResult; trackBy: trackId; index as index">
					<td *ngIf="!isSelectAll">
						<input (click)="toggleSelect($event, index, result, true); $event.stopPropagation()" [checked]="isSelected(result)" class="form-check-input" type="checkbox">
					</td>
					<td>
						<a class="link" (click)="germplasmDetailsPopupService.open(result.germplasmId)">
							<truncate-span [textInput]="result.germplasmId">
							</truncate-span>
						</a>
					</td>
					<td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS">
						<a class="link" (click)="germplasmDetailsPopupService.open(result.germplasmId)">
							<truncate-span [textInput]="result.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE">
							</truncate-span>
						</a>
					</td>
					<ng-container *ngFor="let obs of result.traitObservations">
						<td>{{ obs.noOfObs }}</td>
						<td>{{ showRoundOff(obs.successRatio) }}</td>
					</ng-container>
					<td>{{ showRoundOff(result.combinedScore) }}</td>
				</tr>
				</tbody>
			</table>
			<ng-template #nodata>
				<tbody>
				<tr>
					<td class="no-records" colspan="6" jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</ng-template>
		</div>
		<div *ngIf="traitResult && traitResult.length">
			<div class="row">
				<div class="col">
					<div class="pagination-container">
						<div class="pagination-box pagination-box-left">
							<div>
								<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
							</div>
						</div>
						<div class="pagination-box">
							<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
											[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
						</div>
						<div class="pagination-box pagination-box-right">
							<div class="d-flex align-items-center">
								<label class="control-label control-label-left" for="itemsPerPage" jhiTranslate="global.items.per.page"></label>
								<select (change)="resetTable();" [(ngModel)]="itemsPerPage" [disabled]="isLoading" class="form-select ms-2" id="itemsPerPage" style="width:95px">
									<option value="20">20</option>
									<option value="50">50</option>
									<option value="75">75</option>
									<option value="100">100</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="row">
	<div class="col-md-12 align-center">
		<button (click)="onBack()" class="btn btn-secondary ms-2" value="back" jhiTranslate="back">Back</button>
		<button (click)="onSave()" [disabled]="!isSaveEnabled()" class="btn btn-primary ms-2" jhiTranslate="multi-trait-query.panel.display.result.save">Save to List</button>
	</div>
</div>
